import { useState, useEffect } from "react";

const SESSION_KEY = "aroan_blog_contact_shown";

export const useBlogContactPopup = (delayMs: number = 3000) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Verificar se já foi mostrado nesta sessão
    const alreadyShown = sessionStorage.getItem(SESSION_KEY);
    
    if (alreadyShown) return;

    // Configurar timer para abrir após delay
    const timer = setTimeout(() => {
      setIsOpen(true);
      sessionStorage.setItem(SESSION_KEY, "true");
    }, delayMs);

    // Cleanup do timer se componente desmontar
    return () => clearTimeout(timer);
  }, [delayMs]);

  return { isOpen, setIsOpen };
};
